import { Controller } from "@hotwired/stimulus";

// Add/remove-leg logic for the multi-city searchfield, replacing the old
// jQuery add_multi_leg/remove_multi_leg (searchfield_functions.ts). Each leg
// section is a full DOM block (0..9) rendered server-side and toggled
// visible/hidden here, rather than built dynamically -- matches the old
// behavior's actual approach (fixed 10 leg slots) and keeps every leg's
// autocomplete/datepicker Stimulus controllers already connected from page
// load, no re-initialization needed on add/remove.
export default class extends Controller {
  static targets = ["noLegs", "leg", "addButton"];

  addLeg(event) {
    event.preventDefault();
    const current = Number(this.noLegsTarget.value);
    if (current >= 10) return;

    const newLeg = this.legTargets[current];
    newLeg.classList.remove("hidden");
    this.noLegsTarget.value = current + 1;

    const prevLeg = this.legTargets[current - 1];
    if (prevLeg) {
      const prevDestText = prevLeg.querySelector('input[name*="[destination_text]"]');
      const prevDestId = prevLeg.querySelector('input[name*="[destination_id]"]');
      const newOriginText = newLeg.querySelector('input[name*="[origin_text]"]');
      const newOriginId = newLeg.querySelector('input[name*="[origin_id]"]');
      if (prevDestText && newOriginText && prevDestText.value) {
        newOriginText.value = prevDestText.value;
        newOriginId.value = prevDestId.value;
      }

      const prevDateField = prevLeg.querySelector('input[data-datepicker-target="dateField"]');
      const newDatepickerEl = newLeg.querySelector('[data-controller="datepicker"]');
      if (prevDateField && prevDateField.value && newDatepickerEl) {
        const prevDate = new Date(prevDateField.value);
        prevDate.setDate(prevDate.getDate() + 7);
        const y = prevDate.getFullYear();
        const m = String(prevDate.getMonth() + 1).padStart(2, "0");
        const d = String(prevDate.getDate()).padStart(2, "0");
        newDatepickerEl.dataset.datepickerDefaultDateValue = `${y}-${m}-${d}`;
      }
    }

    if (current + 1 === 10 && this.hasAddButtonTarget) this.addButtonTarget.classList.add("hidden");
  }

  removeLeg(event) {
    event.preventDefault();
    const removeIndex = Number(event.currentTarget.dataset.legIndex);
    const highestIndex = Number(this.noLegsTarget.value) - 1;
    if (highestIndex < 2) return; // keep at least 2 legs

    for (let i = removeIndex; i < highestIndex; i++) {
      const from = this.legTargets[i + 1];
      const to = this.legTargets[i];
      ["origin_text", "origin_id", "destination_text", "destination_id"].forEach((field) => {
        const fromInput = from.querySelector(`input[name*="[${field}]"]`);
        const toInput = to.querySelector(`input[name*="[${field}]"]`);
        if (fromInput && toInput) toInput.value = fromInput.value;
      });
    }

    this.legTargets[highestIndex].classList.add("hidden");
    this.noLegsTarget.value = highestIndex;
    if (this.hasAddButtonTarget) this.addButtonTarget.classList.remove("hidden");
  }
}
